module.exports = __webpack_public_path__ + "media/images/faq/1-100-9b809ab23dfe3ba0262f724978cb1ee4.jpg";